import fetchHelper from '../../../../utils/fetchHelper'
import { captureFetchException } from '../../../../utils/sentryUtils'
import { store } from '../../../../app/store'

export interface NlpFilterUserInfo {
  name: string
  id: string
  avatar?: string // 服务端已返回此字段，直接使用无需动态获取
  userID?: string // 可选，如果没有则使用 id
}

export interface NlpFilterDepartmentInfo {
  name: string
  id: number
  peopleNum: number
  avatar?: string
}

export interface NlpFilterTimeParams {
  startTime?: string
  endTime?: string
}

export interface NlpFilterContent {
  userInfoList?: NlpFilterUserInfo[]
  departmentInfoList?: NlpFilterDepartmentInfo[]
  keywords?: string[]
  timeParams?: NlpFilterTimeParams
}

export interface NlpFilterResponseData {
  status?: number
  msg?: string
  isNlpFilter?: boolean
  filter?: NlpFilterContent
}

// 声明 webpack DefinePlugin 定义的全局变量
declare const __API_SERVER_HOST__: string

export interface NlpFilterResponse {
  code?: number
  msg?: string
  toast_msg?: string
  data?: NlpFilterResponseData
}

export const fetchNlpFilterResult = async (params: {
  groupID: string
  keyword: string
}): Promise<NlpFilterResponse> => {
  const config = {
    url: __API_SERVER_HOST__ + '/v5/workgroup/photos/search/filter',
    arguments: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    }
  }

  return fetchHelper(store.dispatch, store.getState, config)
    .then((result: any) => {
      return result as NlpFilterResponse
    })
    .catch((err) => {
      captureFetchException(err, config as any)
      return Promise.reject(null)
    })
}

export interface NlpPolishingRequest {
  keyword?: string
  groupID?: string
  userInfoList?: NlpFilterUserInfo[]
  departmentInfoList?: NlpFilterDepartmentInfo[]
}

export interface NlpPolishingResponseData {
  status?: number
  msg?: string
  keywordPolished?: string
}

export interface NlpPolishingResponse {
  code?: number
  msg?: string
  toast_msg?: string
  data?: NlpPolishingResponseData
}

export const fetchNlpKeywordPolishing = async (
  params: NlpPolishingRequest
): Promise<NlpPolishingResponse> => {
  const config = {
    url:
      __API_SERVER_HOST__ + '/v5/workgroup/photos/search/filter/name/polishing',
    arguments: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    }
  }

  return fetchHelper(store.dispatch, store.getState, config)
    .then((result: any) => {
      return result as NlpPolishingResponse
    })
    .catch((err) => {
      captureFetchException(err, config as any)
      return Promise.reject(null)
    })
}

// 向量化猜你想搜接口类型定义
export interface SuggestedSearchItem {
  exist: boolean
  word: string
  count: number
}

export interface VectorizedSuggestedSearchData {
  status?: number
  msg?: string
  suggested?: SuggestedSearchItem[]
}

export interface VectorizedSuggestedSearchResponse {
  code?: number
  msg?: string
  toast_msg?: string
  data?: VectorizedSuggestedSearchData
}

export interface VectorizedSuggestedSearchParams {
  groupID?: string
  keyword?: string
  departmentIDs?: string[]
  userIDs?: string[]
  times?: Array<{
    start?: string
    end?: string
  }>
}

/**
 * 获取向量化猜你想搜结果
 */
export const fetchVectorizedSuggestedSearch = async (
  params: VectorizedSuggestedSearchParams
): Promise<VectorizedSuggestedSearchResponse> => {
  const config = {
    url: __API_SERVER_HOST__ + '/v5/workgroup/photos/search/suggested/count',
    arguments: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    }
  }

  return fetchHelper(store.dispatch, store.getState, config)
    .then((result: any) => {
      return result as VectorizedSuggestedSearchResponse
    })
    .catch((err) => {
      captureFetchException(err, config as any)
      return Promise.reject(null)
    })
}
